module.exports = __webpack_public_path__ + "img/studentCount.7e420346.png";